/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface NotificationsUiModuleBody
 */
export interface NotificationsUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    moduleType: NotificationsUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof NotificationsUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof NotificationsUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof NotificationsUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof NotificationsUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * Lokalise key for header text
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    header: string;
    /**
     * Lokalise key for subheader text
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    subheader?: string;
    /**
     * Lokalise key for body text
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    text_body?: string;
    /**
     * Lokalise key for primary call-to-action
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    primary_cta?: string;
    /**
     * Lokalise key for secondary call-to-action
     * @type {string}
     * @memberof NotificationsUiModuleBody
     */
    secondary_cta?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum NotificationsUiModuleBodyModuleTypeEnum {
    NOTIFICATIONS = 'NOTIFICATIONS'
}



